<template>
  <div :class="cssParentClass">
    <form-group>
      <label class="control-label" v-if="name" >{{ name }}</label>
      <div>
        <button-cta v-if="!isDisabled" :onClick="trigger">
          <i v-if="icon" :class="`fa fa-${icon}`" aria-hidden="true"></i>
          {{ ctaText }}
        </button-cta>
        <button-cta v-if="isDisabled" :onClick="trigger" disabled>
          <i v-if="icon" :class="`fa fa-${icon}`" aria-hidden="true"></i>
          {{ ctaText }}
        </button-cta>
      </div>
      <input type="file" ref="fileInput" class="uploadFile__input" @change="fileChange" multiple="multipleFiles" name="upload"
             :accept="acceptedFileType">
      <span class="help-block" v-if="error">{{ error }}</span>
    </form-group>
  </div>
</template>

<script>
import FormGroup from '@/components/Form/FormGroup/form-group'
import ButtonCta from '@/components/Button/button'
export default {
  name: 'UploadFile',
  components: {
    FormGroup,
    ButtonCta
  },
  props: {
    name: String,
    acceptedFileType: String,
    ctaText: {
      type: String,
      default: 'Upload'
    },
    error: String,
    icon: String,
    multipleFiles: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  mounted () {},
  data: () => ({}),
  computed: {
    cssParentClass () {
      return `uploadFile${this.error ? ' has-error' : ''}`
    }
  },
  methods: {
    trigger () {
      this.$refs.fileInput.value = null
      this.$refs.fileInput.click()
    },
    fileChange (event) {
      this.$emit('input', event)
    }
  }
}
</script>

<style lang="scss">
    .uploadFile {
      .form-group {
        margin-bottom: 0;
      }
      &__input {
        visibility: hidden;
        width: 1px;
        height: 1px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/UploadFile/upload-file.vue